import { css } from '@emotion/react';

export const footerCss = css`
 margin-top: 50px;
 background-color: #222!important;
 color: white;
 
`;